import {
  ArrowIcon,
  Box,
  Button,
  CheckIcon,
  Divider,
  Flex,
  Image,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';

import useResponsiveValue from '@app/hooks/useResponsiveValue';

import checkbox from './assets/checkbox.png';
import image from './assets/image.png';
import text from './assets/text.png';

interface RequesterFieldHasEmptyValueConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function RequesterFieldHasEmptyValueConfirmModal({
  isOpen,
  onClose,
  onConfirm,
}: RequesterFieldHasEmptyValueConfirmModalProps) {
  const isMobileWidth = useResponsiveValue([true, undefined, false]);

  return (
    <Modal isOpen={isOpen} maxWidth={isMobileWidth ? 'xxs' : 'md'} onClose={onClose}>
      <ModalTitle>빈 입력란 삭제</ModalTitle>
      <ModalContent textAlign="center">
        <Text as="p" mb={7}>
          문서 편집을 위해 추가한 입력란 중 빈 입력란이 있습니다.
          <br />
          모두 삭제하고 진행하시겠습니까?
        </Text>
        {isMobileWidth ? (
          <Box
            bg="boxBackgroundNeutralBase"
            border="1px solid"
            borderColor="boxBorderNeutralBase"
            px={6}
            py={7}
            textAlign="left"
          >
            <Flex alignItems="center" mb={2}>
              <CheckIcon color="iconNeutralSlightlyDark" mr={2} variant="line" />
              <Text fontSize="sm">빈 텍스트 입력란</Text>
            </Flex>
            <Flex alignItems="center" mb={2}>
              <CheckIcon color="iconNeutralSlightlyDark" mr={2} variant="line" />
              <Text fontSize="sm">빈 체크박스</Text>
            </Flex>
            <Flex alignItems="center">
              <CheckIcon color="iconNeutralSlightlyDark" mr={2} variant="line" />
              <Text fontSize="sm">빈 이미지 입력란</Text>
            </Flex>
          </Box>
        ) : (
          <Flex
            bg="boxBackgroundNeutralSlightlyLight"
            justifyContent="space-between"
            px={6}
            py={8}
            width="100%"
          >
            <Box>
              <Flex alignItems="center" justifyContent="center" mb={4}>
                <CheckIcon mr={2} variant="line" />
                <Text fontSize="sm" fontWeight="medium">
                  빈 텍스트 입력란
                </Text>
              </Flex>
              <Box>
                <Image height="120px" src={text} width="156px" />
              </Box>
            </Box>
            <Divider color="light" direction="column" />
            <Box>
              <Flex alignItems="center" justifyContent="center" mb={4}>
                <CheckIcon mr={2} variant="line" />
                <Text fontSize="sm" fontWeight="medium">
                  빈 체크박스
                </Text>
              </Flex>
              <Box>
                <Image height="120px" src={checkbox} width="156px" />
              </Box>
            </Box>
            <Divider color="light" direction="column" />
            <Box>
              <Flex alignItems="center" justifyContent="center" mb={4}>
                <CheckIcon mr={2} variant="line" />
                <Text fontSize="sm" fontWeight="medium">
                  빈 이미지 입력란
                </Text>
              </Flex>
              <Box>
                <Image height="120px" src={image} width="156px" />
              </Box>
            </Box>
          </Flex>
        )}
      </ModalContent>
      <ModalFooter>
        <Button type="button" onClick={onClose}>
          닫기
        </Button>
        <Button ml={2} type="button" variant="primary" onClick={onConfirm}>
          삭제하고 다음 단계로
          <ArrowIcon direction="right" ml={2} />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
